import type { TagRecord } from './InlineTagsCell';

/** The two calls tag creation makes, as platformService has them. */
export interface TagApi {
  getTags: (query: string) => Promise<TagRecord[]>;
  addTag: (data: { Name: string }) => Promise<{ data: TagRecord }>;
}

/**
 * The tag named `name`: the one in use if there is one (a deleted one does not count), else a new one. Never makes a
 * second tag of a name. Returned without OData's `@odata.context`, so it can join the app's tag list as it is.
 */
export const findOrCreateTag = async (api: TagApi, name: string): Promise<TagRecord> => {
  const existing = await api.getTags(`?$filter=Name eq '${encodeURIComponent(name.replace(/'/g, "''"))}'`);
  const found = existing.find(tag => !tag.IsDeleted) ?? (await api.addTag({ Name: name })).data;
  const tag: TagRecord & { '@odata.context'?: string } = { ...found };
  delete tag['@odata.context'];
  return tag;
};

/** The tag list with `tag` in it - the same list when it is already there, so nothing redraws for it. */
export const withTag = (tags: TagRecord[] | null | undefined, tag: TagRecord): TagRecord[] =>
  (tags ?? []).some(other => other.Id === tag.Id) ? tags : [...(tags ?? []), tag];
